import React, { useState } from 'react'
import {
    Dropdown,
    DropdownToggle,
    DropdownMenu,
    DropdownItem,
} from 'reactstrap'
import { isEmpty } from 'lodash'
import { connect } from 'react-redux'
import { withRouter, Link } from 'react-router-dom'
import { withNamespaces } from 'react-i18next'
import user1 from '../../../assets/images/users/avatar-1.jpg'

const ProfileMenu = (props) => {
    const [menu, setMenu] = useState(false)

    const toggle = () => {
        setMenu(!menu)
    }

    const setAvatar = () => {
        if (!isEmpty(props.user)) {
            if (!isEmpty(props.user.avatar)) {
                return props.user.avatar
            }
            if (!isEmpty(props.user.avatarDefault)) {
                if (!isEmpty(props.user.avatarDefault.avatarUrl)) {
                    return props.user.avatarDefault.avatarUrl
                }
            }
        }
        return user1
    }

    return(
        <React.Fragment>
            <Dropdown
                isOpen={menu}
                toggle={ toggle }
                className="d-inline-block"
            >
                <DropdownToggle
                    className="btn header-item waves-effect"
                    id="page-header-user-dropdown"
                    tag="button"
                >
                    <img className="rounded-circle header-profile-user"
                        src={setAvatar()}
                        alt={props.user.firstName}
                    />
                    <span className="d-none d-xl-inline-block ml-2 mr-1">
                        {props.user.username}
                    </span>
                    <i className="mdi mdi-chevron-down d-none d-xl-inline-block"></i>
                </DropdownToggle>
                <DropdownMenu right>
                    <DropdownItem tag="a" href="/perfil" onClick={() => {
                        window.analytics.track("Go to profile")
                    }}>
                        <i className="bx bx-user font-size-16 align-middle mr-1"></i>
                        {props.t("Profile")}
                    </DropdownItem>

                    <DropdownItem tag="a" href="/direcciones-envio" onClick={() => {
                        window.analytics.track("Go to Addresses")
                    }}>
                        <i className="bx bx-send font-size-17 align-middle mr-1"></i>
                        {props.t("DeliverySent")}
                    </DropdownItem>
                    
                    <div className="dropdown-divider"></div>
                    <Link to="/logout" className="dropdown-item">
                        <i className="bx bx-power-off font-size-16 align-middle mr-1 text-danger"></i>
                        <span>{props.t("Logout")}</span>
                    </Link>
                </DropdownMenu>
            </Dropdown>
        </React.Fragment>
    )
}

const mapStatetoProps = (state) => {
    return {
        user: state.Login.user
    }
}

export default connect(
    mapStatetoProps, {}
)(withRouter(withNamespaces()(ProfileMenu)))
